/**
 * tickPhaseRunner — Run named orchestrator phases with optional ms timings.
 */

export function runTimedTickPhases(
  phases = [],
  phaseCtx = {},
  { record = false, now = () => performance.now() } = {}
) {
  const timingsMs = {};
  for (const phase of phases) {
    if (!phase || typeof phase.fn !== 'function') continue;
    if (!record) {
      phase.fn(phaseCtx);
      continue;
    }
    const t0 = now();
    phase.fn(phaseCtx);
    timingsMs[phase.id] = now() - t0;
  }
  return timingsMs;
}
